module.exports = __webpack_public_path__ + "static/img/DENNIS_LILLEE.94e90c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DENNIS_LILLEE.jpg
// module id = +guj
// module chunks = 0